import React, { useContext } from "react";
import { useEffect } from "react";
import { inIframe } from "../common/Utils";

/* Provides context that allows any children to determine the display context of the app, without having to check URL
 ** explicitly each time. Used for Salesforce iframe display modes. */

const DisplayContext = React.createContext();

export function useDisplayContext() {
  return useContext(DisplayContext);
}

// Create URLSearchParams string for a given opportunity
export function createUrlSearchParams(opp, companyId) {
  let newUrlSearchParams = new URLSearchParams();
  newUrlSearchParams.append("display", "iframe");
  newUrlSearchParams.append("companyId", companyId);
  newUrlSearchParams.append("functionalArea", opp.functionalArea);
  newUrlSearchParams.append("opportunityId", opp.id || opp.opportunityId);
  return newUrlSearchParams.toString();
}

export function DisplayContextProvider({ children }) {
  const [displayMode, setDisplayMode] = React.useState(null);
  // When SFDC landing provides company ID, functional area, or opportunity ID

  let params = new URLSearchParams(document.location.search);
  const [presetCompany, setPresetCompany] = React.useState({
    companyId: params.get("companyId"),
    functionalArea: params.get("functionalArea"),
    opportunityId: params.get("opportunityId"),
  });

  let displayModeParam = params.get("display");

  // Set the display mode once. Should not be changed after.
  useEffect(() => {
    setDisplayMode(displayModeParam);
  }, []);

  return (
    <DisplayContext.Provider
      value={{
        displayMode: displayMode,
        presetCompany: presetCompany,
      }}
    >
      {children}
    </DisplayContext.Provider>
  );
}
